<script>
	import FixedButtons from './../components/FixedButtons.svelte';
     import HrStaffingDashboard from '../pages/hr/StaffingDashboard.svelte';
     import HrStaffingAggregate from '../pages/hr/StaffingAggregate.svelte';
     import HrStaff from '../pages/hr/Staff.svelte';
     import HrCandidates from '../pages/hr/Candidates.svelte';
     import HrCensus from '../pages/hr/Census.svelte';
     import HrPlans from '../pages/hr/Plans.svelte';
     import { onMount } from 'svelte';

     export let user, params;

     let page, loading = true, component;
     let routes = {
          'staffing-dashboard' : HrStaffingDashboard,
          'staffing-agregate' : HrStaffingAggregate,
          'staff' : HrStaff,
          'candidates' : HrCandidates,
          'census' : HrCensus,
          'plans' : HrPlans
     }

    $: setTab(params); //Use to detect when url changed

    function setTab() {
         page = (params.subMenu)? routes[params.subMenu] : HrDashboard;
    }

     onMount(() => {
          localStorage.removeItem("search");
          setTab();
     });
</script>
<FixedButtons
     bind:params={params}
     bind:component={component}
     on:exportReport={component.exportToExcel}
     on:addRow={component.addRow}
     on:importModal={component.openImportModal}
     on:selectEntries={(data) => component.selectEntries(data.detail.entries)}
     on:search={(data) => component.onSearch(data.detail.search)}
></FixedButtons>
<div id="reportsDiv">
     <svelte:component this={page} params={params} bind:this={component}></svelte:component>
</div>
